// This file was auto-generated by Fern from our API Definition.
/**
 * Subscribable event types — a strict subset of EventType.
 *
 * Values are derived from EventType so the strings stay in sync.
 * To add a new subscribable event type, it must first exist in EventType.
 * When extending this enum, regenerate Fern clients and update the
 * "Available event types" section in `04-webhooks.mdx`.
 */
export const WebhookEventType = {
    WebhooksSubscriptionsTested: "webhooks.subscriptions.tested",
    TracesFetched: "traces.fetched",
    TracesQueried: "traces.queried",
    QueriesRevisionsRetrieved: "queries.revisions.retrieved",
    QueriesRevisionsFetched: "queries.revisions.fetched",
    QueriesRevisionsQueried: "queries.revisions.queried",
    QueriesRevisionsLogged: "queries.revisions.logged",
    QueriesRevisionsCommitted: "queries.revisions.committed",
    TestcasesFetched: "testcases.fetched",
    TestcasesQueried: "testcases.queried",
    TestsetsRevisionsRetrieved: "testsets.revisions.retrieved",
    TestsetsRevisionsFetched: "testsets.revisions.fetched",
    TestsetsRevisionsQueried: "testsets.revisions.queried",
    TestsetsRevisionsLogged: "testsets.revisions.logged",
    TestsetsRevisionsCommitted: "testsets.revisions.committed",
    WorkflowsRevisionsRetrieved: "workflows.revisions.retrieved",
    WorkflowsRevisionsFetched: "workflows.revisions.fetched",
    WorkflowsRevisionsQueried: "workflows.revisions.queried",
    WorkflowsRevisionsLogged: "workflows.revisions.logged",
    WorkflowsRevisionsCommitted: "workflows.revisions.committed",
    EnvironmentsRevisionsRetrieved: "environments.revisions.retrieved",
    EnvironmentsRevisionsFetched: "environments.revisions.fetched",
    EnvironmentsRevisionsQueried: "environments.revisions.queried",
    EnvironmentsRevisionsLogged: "environments.revisions.logged",
    EnvironmentsRevisionsCommitted: "environments.revisions.committed",
};
